import React, { useState } from "react";
import "react-sweet-progress/lib/style.css";
import NoImageIcon from "../../images/no-image-icon.png";
import moment from "moment";
import { useMutation } from "@apollo/client";
import { END_DEAL } from "../../mutation/endDeal";
import { hasuraClient } from "../../apolloClient";
import { Spinner } from "react-bootstrap";
import { useHistory, Link } from "react-router-dom";
import Arrow from "../../images/Arrow-Right.svg";

const DealsDetails = ({
  setIsShowEditDesc,
  generalInfo,
  expirationData,
  dealId,
}) => {
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const [endDeal] = useMutation(END_DEAL, {
    client: hasuraClient,
  });

  let getWeek = {
    0: "SUNDAY",
    1: "MONDAY",
    2: "TUESDAY",
    3: "WEDNESDAY",
    4: "THURSDAY",
    5: "FRIDAY",
    6: "SATURDAY",
  };

  const handleEnd = () => {
    setLoading(true);
    endDeal({
      variables: {
        id: dealId,
      },
    })
      .then(() => {
        setLoading(false);
        history.push("/deals");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <section className="event-free-block deals-block">
        <div className="event-free-header">
          <div className="event-col-left back-button">
            <Link to="/deals">
              <img src={Arrow} alt="arrow right" />
            </Link>
            <h3> {generalInfo.dealName}</h3>
          </div>

          <div className="event-col-right submit">
            <div className="edit-deal">
              <a
                href="javascript:void(0)"
                className="secondary-button"
                onClick={() => {
                  setIsShowEditDesc(false);
                }}
              >
                Edit Deal
              </a>
            </div>
            <div className="edit-deal">
              <a
                href="javascript:void(0)"
                className="submit-btn primary-button"
                onClick={() => {
                  handleEnd();
                }}
              >
                {loading ? (
                  <Spinner
                    className="spinner"
                    animation="border"
                    role="status"
                    style={{ height: "20px", width: "20px" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                ) : (
                  "End Deal"
                )}
              </a>
            </div>
          </div>
        </div>

        <div className="event-full-image">
          <div className="image">
            {generalInfo.uploadedImg ? (
              <img src={generalInfo.uploadedImg} alt="image" />
            ) : (
              <img src={NoImageIcon} alt="image" />
            )}
          </div>
          <p>
            EXPIRES ON {getWeek[new Date(expirationData.date).getDay()]},
            {moment(expirationData.date).format("DD MMM")} at{" "}
            {moment(expirationData.time).format("h:mm a")}
          </p>
        </div>

        <div className="event-free-details">
          <div className="event-col-71">
            <div className="event-details">
              <h2>Description</h2>
              <p>{generalInfo.desc} </p>
              <h2>Conditions</h2>
              <p>{generalInfo.condition} </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="ticket-section deals-ticket">
        <div className="ticket-sales-main">
          <div className="ticket-sales-cover">
            <div className="main-title">
              <h2>Deals Performance</h2>
            </div>
            <div className="ticket-row">
              <div className="ticket-col-50">
                <div className="deals-performance-chart"></div>
              </div>
              <div className="ticket-col-50">
                <div className="sales-right-row">
                  <ul className="performance-list">
                    <li>
                      <p>
                        Deal claimed <span>300</span>
                      </p>
                    </li>
                    <li>
                      <p>
                        Deal view <span>1200</span>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shares-event-row">
          <div className="main-title">
            <h2>Deals Claimed</h2>
          </div>
          <div className="share-event-chart-block">
            <div className="datepicker-row">
              <DatePicker
                selected={date}
                dropdownMode="select"
                autoComplete="off"
                onChange={(value) => {
                  setDate(value);
                }}
                className="react-time-input"
                calendarClassName="react-time-picker"
                popperClassName="react-time-propper"
              />
            </div>
            <div className="bar-chart-row">
              <DealsClaimedchart />
            </div>
            <div className="bar-bottom">
              <div className="bar-left">
                <p>Total Claimed</p>
              </div>
              <div className="bar-right">
                <p>
                  10.0%<span>300</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default DealsDetails;
